// extracted by mini-css-extract-plugin
export var columnItem = "_c2-3";
export var columnItemDraggable = "_c2-4";
export var dragHandle = "_c2-0";
export var dragHandleHovered = "_c2-1";
export var dropdown = "_c2-5";
export var dropdownContent = "_c2-7";
export var dropdownInner = "_c2-6";
export var filterDropdownHeader = "_c2-8";
export var icon = "_c2-2";
export var sectionDivider = "_c2-9";